import React, { useEffect, useRef, useState } from 'react';
import { DotLottie } from '@lottiefiles/dotlottie-web';
import styled from 'styled-components';
const Wrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;
export const LottieAnimation = ({ src, loop = true, autoplay = true, className, }) => {
    const dotLottieRef = useRef(null);
    const canvasRef = useRef(null);
    const [canvasId] = useState(() => `dotlottie-canvas-${Math.random().toString(36).substr(2, 9)}`);
    useEffect(() => {
        if (canvasRef.current) {
            const dotLottie = new DotLottie({
                src: `data:application/json;base64,${btoa(JSON.stringify(src))}`,
                loop,
                autoplay,
                canvas: canvasRef.current,
            });
            dotLottieRef.current = dotLottie;
        }
        return () => {
            var _a, _b;
            if (dotLottieRef.current) {
                (_b = (_a = dotLottieRef.current).destroy) === null || _b === void 0 ? void 0 : _b.call(_a);
                dotLottieRef.current = null;
            }
        };
    }, [src, loop, autoplay]);
    return (React.createElement(Wrapper, { className: className, id: "lottie-animation" },
        React.createElement("canvas", { ref: canvasRef, id: canvasId })));
};
